<template>
  <div class="flex-direction">
    <div class="table-container-v3">
      <table class="table table-v3 is-fullwidth is-striped">
        <thead>
          <tr>
            <th>Identificador</th>
            <th>Nombre</th>
            <th>Estatus</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody v-if="!isLoading">
          <tr v-for="rol in roles" :key="rol.id">
            <td>
              <span>{{rol.id}}</span>
            </td>
            <td>
              <span>{{getRoleName(rol)}}</span>
            </td>
            <td class="has-text-centered">
              <span class="is-status" :class="rol.enabled ? 'is-status-active' : 'is-status-inactive'">
                {{ rol.enabled ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td class="has-text-centered">
              <div class="dropdown is-hoverable">
                <a
                  id="panelNavBurger"
                  role="button"
                  data-target="panelNavMenu"
                  aria-expanded="false"
                  aria-label="menu"
                  class="dropbtn"
                >
                  <i class="fas fa-ellipsis-v" />
                </a>
                <div class="dropdown-content">
                  <a class="navbar-item" @click="goToDetail(rol.id)">
                    <i class="show-on-hover fas fa-chevron-right" />
                    Detalle
                  </a>
                  <a class="navbar-item" @click="toggleSwitchModal(rol.id, rol.enabled ? 'Desactivar' : 'Activar')" v-if="['admin', 'intelligential', 'manager', 'compliance'].includes(role.code)">
                    <i class="show-on-hover fas fa-chevron-right" />
                    {{ rol.enabled ? 'Desactivar' : 'Activar' }}
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr v-for="n in 8" :key="n">
            <td><div class="-loading-text -w30"></div></td>
            <td><div class="-loading-text -w70"></div></td>
            <td><div class="-loading-text -w50"></div></td>
            <td><div class="-loading-text -w30"></div></td>
          </tr>
        </tbody>

      </table>
      <div v-if="!isLoading && roles.length == 0" class="-mb-4">
          <p class="-text3 -gray">Sin información</p>
        </div>
    </div>
    <div class="column is-12 has-text-centered">
      <paginator :page="pagination.pageNumber" :pages="pagination.totalPages" :loading="false" :action="getRoles" />
    </div>
    <ModalComponent
      :active="showSwitchModal"
      @cancel="toggleSwitchModal"
      @hdlOnClick="switchRole"
      :textSave="'Continuar'"
      :loader="loading"
      :titleModal="`${status} rol`"
      >
          <div>
            <div class="field">
              <label class="label has-text-centered">¿Estas seguro de {{ status }} este rol?</label>
            </div>
          </div>
    </ModalComponent>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mixins from '@/mixins/formats'
export default {
  name: 'RolesList',
  mixins: [mixins],
  components: {
    Paginator: () => import('@/components/ui/BasePagination.vue'),
    ModalComponent: () => import('@/components/ui/ModalComponent.vue')
  },
  props: {
    roles: {
      type: Array
    },
    pagination: {
      type: Object
    },
    getRoles: {
      type: Function
    },
    isLoading: {
      type: Boolean
    },
    role: {
      type: Object
    }
  },
  data () {
    return {
      showSwitchModal: false,
      loading: false,
      status: ''
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration
    })
  },
  methods: {
    goToDetail (roleId) {
      this.$router.push({
        name: 'profile-role-detail',
        params: {
          roleId,
          tabName: 'politicas-de-sesion'
        }
      })
    },
    toggleSwitchModal (rolId, status) {
      this.rolId = rolId
      this.status = status
      this.showSwitchModal = !this.showSwitchModal
    },
    async switchRole () {
      this.loading = true
      // integrar servicio de actualizar estado de rol
      this.getRoles(0, 10)
      this.showSwitchModal = false
      this.loading = false
    }
  }
}
</script>
